/**
 * @param {number} timestamp
 * @returns {Date}
 */
export function parseDate(timestamp) {
    return new Date(timestamp * 1000);
}

export function getSelect2Locale() {
    return document.documentElement.getAttribute('lang') === 'cs'
        ? require('select2/src/js/select2/i18n/cs.js')
        : require('select2/src/js/select2/i18n/en.js');
}
